const differentiators = [
  {
    icon: "ri-search-eye-line",
    title: "We Diagnose, Not Just Replace",
    body: "Most contractors swap parts. We find the actual root cause — inverter faults, wiring degradation, shading losses — and fix it properly the first time.",
  },
  {
    icon: "ri-shield-check-line",
    title: "One Licensed Team for Everything",
    body: "Solar repair, battery storage, and electrical all handled by the same crew. No subcontractors, no coordination gaps, full accountability.",
  },
  {
    icon: "ri-tools-line",
    title: "Workmanship That Holds Up",
    body: "Clean conduit runs, proper weatherproofing, code-compliant connections. Our repairs and installs are built to last — not just to pass inspection.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Maximize What You Already Have",
    body: "Before recommending anything new, we optimize your existing system. Battery storage, monitoring, and tuning can dramatically improve ROI.",
  },
];

export default function WhyChooseUs() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-center">

          {/* Left: Image with floating badges */}
          <div className="w-full lg:w-[48%] relative flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: "520px" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/af3e89b10e83cf34edc387d35a1fef31.jpg"
                alt="Expert solar repair and electrical technician"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            {/* Floating BBB badge */}
            <div className="absolute -bottom-5 -right-4 md:right-6 bg-white rounded-2xl px-6 py-5 border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-xl flex-shrink-0">
                  <i className="ri-award-fill text-amber-500 text-2xl"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-400 uppercase tracking-widest">BBB Accredited</div>
                  <div className="text-lg font-black text-gray-900" style={{ fontFamily: "'Syne', sans-serif" }}>A+ Since 2003</div>
                </div>
              </div>
            </div>

            {/* Floating years badge */}
            <div className="absolute top-6 -left-4 md:-left-6 bg-stone-950 rounded-2xl px-5 py-4">
              <div className="text-3xl font-black text-amber-400 leading-none" style={{ fontFamily: "'Syne', sans-serif" }}>21+</div>
              <div className="text-white/60 text-xs mt-1 uppercase tracking-widest">Years of<br />Expertise</div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:flex-1">
            <span className="text-amber-500 text-xs font-bold tracking-[0.2em] uppercase">Why Choose Us</span>
            <h2
              className="text-4xl md:text-5xl font-black text-gray-950 mt-3 mb-6 leading-tight tracking-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              The Difference Is in<br />the Details
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-10 max-w-md">
              Most contractors show up with a quote. We show up with expertise — 21 years of it. There&apos;s a meaningful difference in how we diagnose, repair, and optimize energy systems.
            </p>

            <div className="space-y-6 mb-10">
              {differentiators.map((d) => (
                <div key={d.title} className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-xl flex-shrink-0 mt-0.5 border border-amber-100">
                    <i className={`${d.icon} text-amber-500`}></i>
                  </div>
                  <div>
                    <h3
                      className="text-sm font-black text-gray-900 mb-1"
                      style={{ fontFamily: "'Syne', sans-serif" }}
                    >
                      {d.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{d.body}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => scrollTo("#contact")}
              className="bg-gray-950 hover:bg-gray-800 text-white font-bold px-8 py-4 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 w-fit"
            >
              Get a Free Estimate
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
